import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import { messageInfo } from "@utils/message";
import liff from '@line/liff'
import lineGetProfileAndLogin from "@utils/line-get-profile-and-login";
import Vue from 'vue';
import router from '@router'
import configSSO from "@src/config/sso";

export default [
  // ===
  // 登入
  // ===
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/Login/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLogoutPage: true
    }
  },
  // ===
  // 登出
  // ===
  {
    path: '/logout',
    name: 'logout',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await Promise.all([
            store.dispatch('auth/logOut'),
            store.dispatch('order/clearApplicablePrepaidOrderList')
          ]);
          const { href } = router.resolve({
            name: routeTo.query.redirectFrom ? 'login' : 'home',
            query: {
              liffUserId: routeTo.query.liffUserId || undefined,
              redirectFrom: routeTo.query.redirectFrom || undefined,
            }
          });

          if (configSSO.enabled) {
            store.dispatch('auth/wordpressLogOut', {
              redirect: `${window.location.origin}${href}`
            })
          } else {
            window.location = `${window.location.origin}${href}`
          }

          /* const isMockApi = Vue.prototype.$apiPath.indexOf('mock') !== -1;
          const { href } = router.resolve({
            name: routeTo.query.redirectFrom ? 'login' : 'home',
            query: {
              liffUserId: routeTo.query.liffUserId || undefined,
              redirectFrom: routeTo.query.redirectFrom || undefined,
            }
          });

          if (!isMockApi && configSSO.enabled) {
            if (routeTo.query.success === 'true') {
              await Promise.all([
                store.dispatch('auth/logOut'),
                store.dispatch('order/clearApplicablePrepaidOrderList')
              ]);

              next({
                name: routeTo.query.redirectFrom ? 'login' : 'home',
                query: {
                  liffUserId: routeTo.query.liffUserId || undefined,
                  redirectFrom: routeTo.query.redirectFrom || undefined,
                }
              })
              messageInfo('已登出')
            } else {
              store.dispatch('auth/wordpressLogOut', {
                redirect: `${window.location.origin}${href}`
              })
            }
          } else {
            window.location = `${window.location.origin}${href}`
            return false
          } */
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isNullPage: true,
    },
  },
  // ===
  // LIFF
  // ===
  {
    path: '/liff/:liffId',
    name: 'liff',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          liff.init({
            liffId: routeTo.params.liffId
          })
            .then(() => {
              /* liff.sendMessages([{
               type: 'text',
               text: "test"
               }]); */

              if(liff.isLoggedIn() || (!liff.isLoggedIn() && liff.isInClient())) {
                lineGetProfileAndLogin({
                  liffId: routeTo.params.liffId,
                  redirectFrom: routeTo.query.redirectTo,
                  next
                })
              } else {
                liff.login({ redirectUri: window.location.href })
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isNullPage: true,
    },
  },
  // ===
  // LINE Notify
  // ===
  {
    path: '/line-notify-bind',
    name: 'line-notify-bind',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        const code = routeTo.query.code
        const success = Boolean(routeTo.query.success)

        if (success) {
          try {
            await store.dispatch('auth/lineNotifyBind', { code })
            next({
              name: 'member-info',
              replace: true,
              query: {
                message: 'LINE Notify 綁定成功',
                messageType: 'success',
              }
            })
          } catch (error) {
            console.log(error)
            next({
              name: 'member-info',
              replace: true,
            })
          }
        } else {
          next({
            name: 'member-info',
            replace: true,
            query: {
              message: 'LINE Notify 綁定失敗',
              messageType: 'error',
            }
          })
        }
      },
      isLoginPage: true,
    },
  },
]
